// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-TextArea__wrapper","label":"c-TextArea__label","textarea":"c-TextArea__textarea","floatingLabel":"c-TextArea__floatingLabel"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/TextArea/TextArea.scss
// module id = 501
// module chunks = 0